// extracted by mini-css-extract-plugin
module.exports = {"component":"Faq_component__3XT3s","qa":"Faq_qa__evn9Y","q":"Faq_q__1qhzH","a":"Faq_a__3rPQ0"};